import { React, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { API_URL } from '../../api'

const Home = () => {
    useEffect(() => {
        document.body.style.backgroundImage = 'url("/images/prayerFlags.jpg")';  // Set background image for the home page
        return () => { document.body.style.backgroundImage = 'none'; }; // Clean up function to reset background image on unmount
    }, []);

    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()
        setMessage('')
        try {
            const res = await fetch(`${API_URL}/subscribers`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            })
            if (res.ok) {
                setMessage('Thanks for signing up!')
                setEmail('')
            } else {
                setMessage('There was a problem. Please try again later.')
            }
        } catch (err) {
            setMessage('There was a problem. Please try again later.')
        }
    }

    return (
        <div className="text-center space-y-16">

            <section>
                <div className="bg-black bg-opacity-50 p-8 rounded shadow-lg">
                    <h1 className="text-4xl font-bold text-white mb-4">Cultivating Compassion and Wisdom for All</h1>
                    <p className="text-lg text-white mb-4">We bring the Dharma to the Americas and beyond—serving practitioners in Southeastern Wisconsin and online, offering vows, teachings, and a nurturing digital temple space.</p>
                    <div className="flex justify-center space-x-4">
                        <Link to="/library" className="bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-600 transition">Explore Our Free Resources</Link>
                        <Link to="/mission" className="bg-green-500 text-white font-bold py-2 px-4 rounded hover:bg-green-600 transition">Learn About Our Mission</Link>
                    </div>
                </div>
            </section>

            <section className="p-8 bg-white">
                <h2 className="text-2xl font-bold mb-4">About Us</h2>
                <p className="mb-4">At BuddhaWisdom.org, we dedicate ourselves to preserving the Dharma, building a physical temple and gardens, and fostering a vibrant online community. We welcome everyone—regardless of background or experience level—to access teachings, meditate together, take or renew vows, and cultivate a path of compassion, peace, and understanding.</p>
                <Link to="/mission" className="text-blue-500">Read Our Mission</Link>
            </section>

            <section className="p-8 bg-gray-100">
                <h2 className="text-2xl font-bold mb-4">Future Temple & Land Plans</h2>
                <p className="mt-4">We are seeking 40–100 acres of land (up to 50 hectares) to create a sanctuary with meditation halls, gardens, and room for community growth. Your support helps bring this vision to life.</p>
                <Link to="/mission" className="text-blue-500">View Detailed Plans</Link>
            </section>

            <section className="p-8 bg-white">
                <h2 className="text-2xl font-bold mb-4">Online Resources & Virtual Temple Tools</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="p-4 bg-gray-100 rounded shadow-md">
                        <h3 className="text-xl font-bold mb-2">Library of Wisdom</h3>
                        <p className="mb-2">Learn Mantras, Read Suttas, and Explore Buddhist Teachings</p>
                        <Link to="/library" className="text-blue-500">Enter the Library</Link>
                    </div>
                    <div className="p-4 bg-gray-100 rounded shadow-md">
                        <h3 className="text-xl font-bold mb-2">Temple for All Beings</h3>
                        <p className="mb-2">Take or renew vows online, listen to mantras, explore chants, meet buddhas/deities.</p>
                        <Link to="/temple" className="text-blue-500">Enter the Virtual Temple</Link>
                    </div>
                    <div className="p-4 bg-gray-100 rounded shadow-md">
                        <h3 className="text-xl font-bold mb-2">Study Resources & E-Books</h3>
                        <p className="mb-2">Guided Meditations & Dharma Talks, PDFs, articles, and guides.</p>
                        <Link to="/library" className="text-blue-500">Browse Library</Link>
                    </div>
                </div>
            </section>


            <section className="p-8 bg-white">
                <h2 className="text-2xl font-bold mb-4">Support & Newsletter Sign-Up</h2>
                <p className="mb-4">Your donations help secure land, build the temple, and maintain free resources.</p>
                <Link to="/donate" className="bg-red-500 text-white font-bold py-2 px-4 rounded mb-4 inline-block">Donate</Link>
                <p className="mb-4">Sign up to receive updates on our progress, new teachings, and upcoming online sessions.</p>
                <form onSubmit={handleSubmit} className="flex flex-col items-center">
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="p-2 border border-gray-300 rounded mb-2 w-1/2" />
                    <button type="submit" className="bg-blue-500 text-white font-bold py-2 px-4 rounded">Sign Up</button>
                </form>
                {message && <p className="mt-2">{message}</p>}
            </section>

            <footer className="p-4 bg-gray-800 text-white space-y-2">
                <p>Contact us at: info@buddhawisdom.org</p>
                <p>Buddha Wisdom Organization — 501(c)(3) Nonprofit</p>
                <p>
                    This project will be entrusted to the
                    <a href="https://fpmt.org" className="text-blue-300 hover:underline ml-1" target="_blank" rel="noreferrer">FPMT</a>
                    &nbsp;upon the passing of Mahayana students Brandon Williams and Logan Schmidt.
                </p>
                <p>May all beings be happy, peaceful, and free from suffering.</p>
            </footer>

        </div>
    )
}

export default Home
